export const getModalRoot = (modalRoot: HTMLElement | null): {
    modalRoot: HTMLElement;
} => {
    if (modalRoot === null) {
        throw new Error('Root element not found');
    }

    if (!(modalRoot instanceof HTMLElement)) {
        throw new Error('Root element is not a HTMLElement');
    }

    return { modalRoot };
};
